import { updateMissionStatement } from "api";
import Notify from "utils/notify";
import { ActionTypes } from "./types";
import { SetMissionStatement } from "Redux/GetMissionStatement/action";

export const UpdateMissionStatement = (Data, id, callback, onError) => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });

    const { data, status } = await updateMissionStatement(Data, id);

    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data,
    });

    if (status === 200) {
      dispatch(SetMissionStatement(data));
      
      if (callback) {
        callback();
      }
    }
  } catch (error) {
    Notify.error(error, true);

    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });

    if (onError) {
      onError(error);
    }
  }
};

export const SetUpdateMissionStatement = (payload) => async (dispatch) => {
  dispatch({
    type: ActionTypes.SUCCESS,
    payload,
  });
};
